import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import styles from './ChoosePaymentMethod.module.css';
import { DesktopView } from './desktop/ChoosePaymentMethod.desktop';
import { MobileView } from './mobile/ChoosePaymentMethod.mobile';
import { Plans } from '../..';
import { PlanCardProps } from '../../../component/parentPortal/planCard/planCard';

export interface ChoosePaymentMethodProps {
  selectedPlan: Plans;
  back(): void;
}

export const ChoosePaymentMethod = (
  props: ChoosePaymentMethodProps,
): JSX.Element => {
  // Redux Hooks

  return (
    <React.Fragment>
      {isMobileOnly ? <MobileView {...props} /> : <DesktopView {...props} />}
    </React.Fragment>
  );
};
